import { useContext } from 'react';
import GlobalContext from '~/context/vdp/GlobalContext';
import useGetShouldRenderBelowSpinner from './useGetShouldRenderBelowSpinner';

// final phase of lazy loading
export default function useShouldLoadBelowFirstSectionStandard() {
  const shouldRenderBelowSpinner = useGetShouldRenderBelowSpinner();
  const { isLazyLoadEnabled } = useContext(GlobalContext);

  return Boolean(shouldRenderBelowSpinner && !isLazyLoadEnabled);
}
